module.exports = "<cities-page></cities-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/cities.html
// module id = 1459
// module chunks = 0